import bindAllMethods from '../../../utils/bindAllMethods';
import { ThemeService } from '../../../services/themeService';
import { ThemeInterfaceType } from '@clientos/types';
import { getServices } from '../../../infra/startup';

class ThemeInterface {
  private _themeService: ThemeService;

  constructor() {
    const services = getServices();
    this._themeService = services.themeService;
    bindAllMethods(this);
  }

  public getInterface(): ThemeInterfaceType {
    return {
      getScreenResponsivelyProperties:
        this._themeService.getScreenResponsivelyProperties,
      getThemeProviderProperties: this._themeService.getThemeProviderProperties,
      getUserThemeMode: this._themeService.getUserThemeMode
    };
  }
}

export default ThemeInterface;
